import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { trackPageView } from '@/lib/analytics';

/**
 * Hook per tracciare automaticamente le visualizzazioni di pagina
 * in un'applicazione Single Page Application (SPA)
 * 
 * Nota: Le pagine entità e foto vengono tracciate rispettivamente da
 * trackEntityPageView e trackPhotoPageView con informazioni aggiuntive
 * (page_type incluso), quindi vengono saltate qui.
 */
export const usePageTracking = () => {
  const [location] = useLocation();

  useEffect(() => {
    // Salta il tracking per le pagine entità e foto: hanno un tracker dedicato
    // che aggiunge page_type. Senza questo skip si avrebbe un page_view duplicato.
    if (
      location.includes('/scheda/') ||
      location.includes('/foto/') ||
      location.includes('/photos/')
    ) {
      return;
    }
    
    // Traccia ogni cambio di pagina
    const timer = setTimeout(() => {
      trackPageView(location, document.title);
    }, 500); // Piccolo delay per assicurarsi che il title sia aggiornato

    return () => clearTimeout(timer);
  }, [location]);
};